<template>
    <div class="extra-container">
        <div class="container-fluid">
            <div class="row second-header-box" v-if="currentTrip.from">
                <div class="col-lg-4 col-sm-12 text-left">
                    <h1 class="way-to blue-txt text-uppercase text-truncate">{{currentTrip.from}} — {{currentTrip.to}}</h1>
                    <h6 class="way-from text-uppercase">{{currentTrip.from}} — {{currentTrip.to}}</h6>
                </div>
                <div class="col-lg-2 col-sm-6">
                    <div class="way-to blue-txt">{{currentTrip.departure_at | moment('HH:mm')}}</div>
                    <div class="way-from text-uppercase">{{currentTrip.from}}</div>
                </div>
                <div class="col-lg-2 col-sm-6">
                    <div class="way-to blue-txt">{{currentTrip.arrive_at | moment('HH:mm')}}</div>
                    <div class="way-from text-uppercase">{{currentTrip.to}}</div>
                </div>
                <div class="col-lg-2 col-sm-6 text-left">
                    <div class="way-to blue-txt">{{time | asTime}}</div>
                    <div class="way-to blue-txt d-none">{{currentTrip.distance}} {{i18n('Km')}}</div>
                </div>
                <div class="col-lg-2 col-sm-6 text-right">
                    <div class="way-to blue-txt" v-if="$route.name === 'web-tickets'">{{currentTrip.price}}</div>
                    <div class="way-to blue-txt" v-else>{{allPrice}}</div>
                    <div class="way-from text-lowercase">{{i18n('sum')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SecondHeader",
        data() {
            return {
                currentTrip: {},
                allPrice: 0,
                time: 5,
            }
        },
        created() {
            this.currentTrip = this.$store.state.selectedTrip;
            this.allPrice = this.$store.state.allPrice ? this.$store.state.allPrice : this.currentTrip.price;
            this.time = (this.$moment(this.currentTrip.arrive_at).unix() - this.$moment(this.currentTrip.departure_at).unix());
        },
        filters: {
            asTime(val) {
                let hour = Math.floor(val / 60 / 60);
                let min = Math.floor(val / 60 % 60);
                return hour + ' ч. ' + min + ' м.'
                // return val
            },
        },
        watch: {
            "$store.state.allPrice": function (val) {
                this.allPrice = val;
            },
            "$store.state.selectedTrip": {
                handler: function (val) {
                    this.currentTrip = val;
                    this.time = (this.$moment(this.currentTrip.arrive_at).unix() - this.$moment(this.currentTrip.departure_at).unix());
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 992px){
        .second-header-box>div{
            border-bottom: 1px solid #dde0e5;
        }
        .second-header-box>div>div,.second-header-box>div>h1,.second-header-box>div>h6{
            text-align: center;
        }
    }
</style>
